// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Web_members_model from "./web_members_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__String from "melange/string.js";

function initial(mode, request_id) {
  return {
    mode,
    request_id,
    email: "",
    role: "member",
    rows: /* [] */ 0,
    cursor: undefined,
    preview: undefined,
    loading: false,
    pending: false,
    uncertain: false,
    message: "",
    members: Mapre_web__Web_members_model.initial
  };
}

function decode(row) {
  return {
    id: Mapre_wire__Json.string(row, "id"),
    email: Mapre_wire__Json.string(row, "email"),
    role: Mapre_wire__Json.string(row, "role"),
    version: Mapre_wire__Json.integer(row, "version"),
    delivery: Mapre_wire__Json.string(row, "delivery"),
    accepted: Caml_obj.caml_notequal(Mapre_wire__Json.get(row, "accepted_at"), null),
    revoked: Caml_obj.caml_notequal(Mapre_wire__Json.get(row, "revoked_at"), null),
    error: Js__Js_json.decodeString(Mapre_wire__Json.get(row, "last_error"))
  };
}

function preview(json) {
  const row = Mapre_wire__Json.get(json, "invitation");
  return {
    workspace: Mapre_wire__Json.string(row, "workspace_id"),
    name: Mapre_wire__Json.string(row, "workspace_name"),
    email: Mapre_wire__Json.string(row, "email"),
    role: Mapre_wire__Json.string(row, "role")
  };
}

function update(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Loading */ 5 :
        return {
          mode: t.mode,
          request_id: t.request_id,
          email: t.email,
          role: t.role,
          rows: t.rows,
          cursor: t.cursor,
          preview: t.preview,
          loading: true,
          pending: t.pending,
          uncertain: t.uncertain,
          message: "",
          members: t.members
        };
      case /* Pending */ 6 :
        return {
          mode: t.mode,
          request_id: t.request_id,
          email: t.email,
          role: t.role,
          rows: t.rows,
          cursor: t.cursor,
          preview: t.preview,
          loading: t.loading,
          pending: true,
          uncertain: t.uncertain,
          message: "",
          members: t.members
        };
      case /* Revoked */ 7 :
        return {
          mode: t.mode,
          request_id: t.request_id,
          email: t.email,
          role: t.role,
          rows: t.rows,
          cursor: t.cursor,
          preview: t.preview,
          loading: t.loading,
          pending: false,
          uncertain: t.uncertain,
          message: "Invitation revoked",
          members: t.members
        };
      default:
        return t;
    }
  } else {
    switch (action.TAG) {
      case /* Email */ 2 :
        if (!t.pending && !t.uncertain) {
          return {
            mode: t.mode,
            request_id: t.request_id,
            email: action._0,
            role: t.role,
            rows: t.rows,
            cursor: t.cursor,
            preview: t.preview,
            loading: t.loading,
            pending: t.pending,
            uncertain: t.uncertain,
            message: t.message,
            members: t.members
          };
        } else {
          return t;
        }
      case /* Role */ 3 :
        if (!t.pending && !t.uncertain) {
          return {
            mode: t.mode,
            request_id: t.request_id,
            email: t.email,
            role: action._0,
            rows: t.rows,
            cursor: t.cursor,
            preview: t.preview,
            loading: t.loading,
            pending: t.pending,
            uncertain: t.uncertain,
            message: t.message,
            members: t.members
          };
        } else {
          return t;
        }
      case /* Listed */ 5 :
        const rows = action._0;
        return {
          mode: t.mode,
          request_id: t.request_id,
          email: t.email,
          role: t.role,
          rows: action._2 ? Stdlib.$at(t.rows, rows) : rows,
          cursor: action._1,
          preview: t.preview,
          loading: false,
          pending: t.pending,
          uncertain: t.uncertain,
          message: t.message,
          members: t.members
        };
      case /* Created */ 6 :
        return {
          mode: t.mode,
          request_id: action._0,
          email: "",
          role: t.role,
          rows: t.rows,
          cursor: t.cursor,
          preview: t.preview,
          loading: t.loading,
          pending: false,
          uncertain: false,
          message: "Invitation queued",
          members: t.members
        };
      case /* Preview */ 7 :
        return {
          mode: t.mode,
          request_id: t.request_id,
          email: t.email,
          role: t.role,
          rows: t.rows,
          cursor: t.cursor,
          preview: action._0,
          loading: false,
          pending: false,
          uncertain: false,
          message: "",
          members: t.members
        };
      case /* Failed */ 8 :
        const uncertain = action._1;
        return {
          mode: t.mode,
          request_id: t.request_id,
          email: t.email,
          role: t.role,
          rows: t.rows,
          cursor: t.cursor,
          preview: uncertain ? t.preview : undefined,
          loading: false,
          pending: false,
          uncertain,
          message: action._0,
          members: t.members
        };
      case /* Members */ 9 :
        return {
          mode: t.mode,
          request_id: t.request_id,
          email: t.email,
          role: t.role,
          rows: t.rows,
          cursor: t.cursor,
          preview: t.preview,
          loading: t.loading,
          pending: t.pending,
          uncertain: t.uncertain,
          message: t.message,
          members: Mapre_web__Web_members_model.update(t.members, action._0)
        };
      default:
        return t;
    }
  }
}

function can_submit(t) {
  if (Caml_obj.caml_equal(t.mode, /* Manage */ 0) && !t.pending && !t.loading) {
    return Stdlib__String.trim(t.email) !== "";
  } else {
    return false;
  }
}

function status(row) {
  if (row.revoked) {
    return "Revoked";
  }
  if (row.accepted) {
    return "Accepted";
  }
  const match = row.delivery;
  switch (match) {
    case "canceled" :
      return "Canceled";
    case "failed" :
      return "Email failed";
    case "sending" :
      return "Sending email";
    case "sent" :
      return "Email sent";
    case "uncertain" :
      return "Email delivery unknown";
    default:
      return "Queued";
  }
}

export {
  initial,
  decode,
  preview,
  update,
  can_submit,
  status,
}
/* Mapre_web__Web_members_model Not a pure module */
